import AuthPage from './auth';

export default AuthPage;
